import { JsonObject, JsonValue } from '../app/json/jsonValue.js';
import { ITransientStore } from './iface/iTransientStore.js';

/**
 * Default per-merge transient state store.
 */
export class TransientStore extends ITransientStore {
    private readonly _state: JsonObject = new JsonObject();

    containsKey(key: string): boolean {
        for (const existingKey of this._state.keys()) {
            if (existingKey === key) {
                return true;
            }
        }
        return false;
    }

    getValue(key: string): JsonValue | null {
        return this._state.has(key) ? this._state.get(key) : null;
    }

    setValue(key: string, value: unknown): void {
        if (this._state.has(key)) {
            this._state.delete(key);
        }
        this._state.set(key, value);
    }

    snapshot(): JsonObject {
        return this._state.deepClone();
    }
}
